import React from 'react';
import { Banner } from '../../../../models';
import CloseButton from './CloseButton';
import styles from '../StaticBanner.module.scss';
import { handleHtmlContentLinkClick } from '../../handleHtmlContentLinkClick';

type Props = {
    banner: Banner;
    onClose: () => void;
    onClick?: () => void;
    onLinkClick?: (url: string) => void | Promise<void>;
}

const BackgroundBanner: React.FC<Props> = ({ banner, onClose, onClick, onLinkClick }) => {
    const hasText = !!(banner.text && banner.text.trim());

    return (
        <div
            className={styles.bannerWithBackground}
            style={{
                backgroundImage: `url(${banner.imageUrl})`,
                cursor: onClick ? 'pointer' : 'default'
            }}
            onClick={onClick}
        >
            <div className={styles.contentRow}>
                {hasText && (
                    <div
                        className={styles.text}
                        onClick={onLinkClick ? e => { void handleHtmlContentLinkClick(e, onLinkClick); } : undefined}
                        dangerouslySetInnerHTML={{ __html: banner.text }}
                    />
                )}
                {banner.staticHideable && (
                    <CloseButton onClick={onClose} inline />
                )}
            </div>
        </div>
    );
};

export default BackgroundBanner;
